export default {
  dark: {
    "disclaimer-text": "neutral-200",
    "oxygen-devices-disclaimer-text": "neutral-200",
    "secondary-contact-type": "neutral-100",
    "secondary-container": "neutral-300",
  },
  light: {
    "disclaimer-text": "neutral-200",
    "oxygen-devices-disclaimer-text": "neutral-200",
    "secondary-contact-type": "neutral-100",
    "secondary-container": "neutral-300",
  },
};
